export enum FileStatus {
  PENDING = 'PENDING',
  ERROR = 'ERROR',
  DONE = 'DONE'
}
